import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
const NAVIGATION_DIVIDER_MARGIN = 27;
export const navigationDividerElementStyles = ({ theme }) => css `
	margin: ${pxToRem(theme.spacing['100'])} 0;
	height: ${theme.borderWidth['2']}px;
	border: 0;
	background-color: ${theme.colors.light.divider};

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		margin: ${pxToRem(NAVIGATION_DIVIDER_MARGIN)} 0;
	}
`;
export const NavigationDividerElement = styled.hr `
	${navigationDividerElementStyles}
`;
